// extracted by mini-css-extract-plugin
export default {"container":"StudentList_container__zIf20","preview":"StudentList_preview__WwLLA","empty":"StudentList_empty__TZXlP"};